import {
  patientStatusSchema,
  type IPatient,
  type IPatientId,
} from "@medoma/models/patients";
import { useOutletContext } from "react-router";

export const NO_PATIENT_SELECTED = "";

export type NewActivityOutletContext = {
  patientId: IPatientId | undefined;
  defaultStartDate: Date | undefined;
};

export const useNewActivityOutletContext = (): NewActivityOutletContext => {
  return useOutletContext<NewActivityOutletContext>();
};

export const canAddActivitiesToPatient = ({
  status,
}: Pick<IPatient, "status">) =>
  [
    patientStatusSchema.enum.prospect,
    patientStatusSchema.enum.admitted,
    patientStatusSchema.enum.discharged,
  ].some((s) => s === status);

const retroactiveStatuses = [
  patientStatusSchema.enum.admitted,
  patientStatusSchema.enum.discharged,
];

export const canRegisterActivitiesRetroactively = ({
  status,
}: Pick<IPatient, "status">) => retroactiveStatuses.some((s) => s === status);
